import * as React from 'react';
import * as style from '../style.module.css';

// Outline-style padlock for locked segments and modules. The opaque disc behind the
// padlock caps the connector line so it doesn't show through the (otherwise transparent)
// outline icon. Disc color (.lockDisc) matches the light panel background.
const OutlineLockIcon: React.FC = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden={true}>
    <circle cx="12" cy="12" r="12" className={style.lockDisc} />
    <rect x="5" y="11" width="14" height="9" rx="1.5" stroke="currentColor" strokeWidth="2" />
    <path d="M8 11V8a4 4 0 0 1 8 0v3" fill="none" stroke="currentColor" strokeWidth="2" />
  </svg>
);

export default OutlineLockIcon;
